// @flow

import { observer } from "mobx-react";
import React from "react";
import { states } from "timelinely-player/TimelinelyPlayer";

import Icon from "app/components/Icon/Icon";

import "./PlayButton.scss";

type Props = {
    state: string,
    onPlay: Function,
    onPause: Function
};

@observer
export default class PlayButton extends React.Component<Props> {
    get playing(): boolean {
        return this.props.state === states.PLAYING;
    }

    handleClick = () => {
        if (this.playing) {
            this.props.onPause()
        } else {
            this.props.onPlay();
        }
    };

    render() {
        const icon = this.playing ? 'pause' : 'play';
        const title = this.playing ? 'Pause' : 'Play';

        return (
            <button className="PlayButton" type="button" onClick={this.handleClick} title={title}>
                <Icon name={icon} fontAwesome={true}/>
            </button>
        )
    }
}


// WEBPACK FOOTER //
// ./src/app/components/PlayButton/PlayButton.js